export function addGtmToPage(gtmCode: string): void {
    const w: any = window,
        d = document,
        s = 'script',
        l = 'dataLayer',
        i = gtmCode;

    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
    });

    const script: HTMLScriptElement = d.createElement(s) as HTMLScriptElement,
        dl = l != 'dataLayer' ? '&amp;l=' + l : '';

    script.async = true;
    script.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;
    document.body.insertBefore(script, document.body.childNodes[0]);
}
